import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, SimpleChanges} from '@angular/core';
import {map} from 'rxjs/operators';
import {SynchronizationDirective} from './synchronization.directive';


@Component({
  selector: 'app-employment-sync-widget',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './synchronization.component.html',
  styleUrls: ['./synchronization.component.css']
})
export class EmploymentSynchronizationComponent extends SynchronizationDirective implements OnChanges {
  @Input() employmentId: number;

  ngOnChanges(changes: SimpleChanges): void {
    this.employmentId = changes.employmentId.currentValue as number;
    if (this.employmentId) {
      this.init()
    }
  }

  private init() {
    this.synchronizationService.getEmploymentOrigins(this.employmentId)
      .pipe(map(items => items.map(item => this.convert(item)))).subscribe(t => {
        this.rows.next(t);
        }, error => {
        console.log(error);
      });
  }
}
